
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z"}}),_c('path',{attrs:{"d":"M12.386 3.75a3.745 3.745 0 013.75 3.75 3.745 3.745 0 01-3.75 3.75 3.745 3.745 0 01-3.75-3.75 3.745 3.745 0 013.75-3.75zM12.01 21a8.545 8.545 0 01-7.125-3.833c.035-2.37 4.75-3.667 7.125-3.667 2.363 0 7.09 1.298 7.125 3.667A8.545 8.545 0 0112.01 21z"}})])
          )
        }
      }
    